import { EXO_SKELETON_EVENT_NAMES } from './consts';
import { createPostMessageEventHandler, hasExoSkeletonListenerInitialized, sendRuntimeDataEvent } from './runtime';
export const TRACKING_HOST_MESSAGE_EVENT_NAME = EXO_SKELETON_EVENT_NAMES.TRACKING_HOST_MESSAGE_EVENT_NAME;
export const TOTAL_REMOTE_LOADING_TIME = 'total-remote-loading-time';
export const TRACKING_ACTIONS = {
  ABORT: 'abort',
  START: 'start',
  END: 'end'
};
function isTrackingDataEvent(data) {
  return (data === null || data === void 0 ? void 0 : data.type) === TRACKING_HOST_MESSAGE_EVENT_NAME;
}
export function createPerformanceTracker(_ref) {
  let {
    onTrack
  } = _ref;
  return createPostMessageEventHandler(TRACKING_HOST_MESSAGE_EVENT_NAME, function (_ref2) {
    let {
      data
    } = _ref2;
    if (isTrackingDataEvent(data)) {
      onTrack(data);
    }
  });
}
export function abortTracking(_ref3) {
  let {
    scope,
    moduleName,
    trackingId,
    reason
  } = _ref3;
  if (!hasExoSkeletonListenerInitialized(TRACKING_HOST_MESSAGE_EVENT_NAME)) {
    console.warn('"abortTracking" was called, but the ExoSkeleton host did not initialize the "createPerformanceTracker". Data sent:', {
      scope,
      moduleName,
      trackingId,
      reason
    });
  }
  return sendRuntimeDataEvent(TRACKING_HOST_MESSAGE_EVENT_NAME, {
    action: TRACKING_ACTIONS.ABORT,
    scope,
    moduleName,
    trackingId,
    metadata: {
      reason
    }
  });
}
export function trackLoadingTime(data) {
  if (!hasExoSkeletonListenerInitialized(TRACKING_HOST_MESSAGE_EVENT_NAME)) {
    console.warn('"trackLoadingTime" was called, but the ExoSkeleton host did not initialize the "createPerformanceTracker". Data sent:', data);
  }
  const {
    scope,
    action,
    trackingId,
    parentTrackingId,
    moduleName,
    isRemoteAlreadyInitialized,
    metadata
  } = data;
  if (!scope) {
    throw new Error('Cannot execute "trackLoadingTime" without scope, please provide your scope i.e.: trackLoadingTime({ scope: "accMyScope", moduleName: "./App" })');
  }
  if (!moduleName) {
    throw new Error('Cannot execute "trackLoadingTime" without moduleName, please provide your moduleName i.e.: trackLoadingTime({ scope: "accMyScope", moduleName: "./App" })');
  }
  return sendRuntimeDataEvent(TRACKING_HOST_MESSAGE_EVENT_NAME, {
    action,
    scope,
    isRemoteAlreadyInitialized,
    moduleName,
    trackingId,
    parentTrackingId,
    metadata
  });
}
//# sourceMappingURL=performance.js.map